import BaseApp from "../modules/base-app";
import DlAppModal from "../pages/dl-app-modal";
import ErrorBoundary from "../utils/error-boundary";

const DlApp = (props) => (
  <ErrorBoundary>
    <BaseApp>
      <DlAppModal {...props} />
    </BaseApp>
  </ErrorBoundary>
);

export default DlApp;
